import { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormGroup, Modal, ModalBody, Form } from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Tooltip from "./../../../components/Tooltip/Tooltip";
import Button from "./../../../components/Button/Button";
import Icon from "../../../components/Icon/Icon";
import ErrorMessage from "../../../helpers/ErrorMessage/ErrorMessage";
import PageHeader from "../../../components/PageHeader/PageHeader";
import { Block } from "./../../../components/Block/Block";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
} from "./../../../components/DataTable/DataTable";
import { Col, Row } from "./../../../components/Grid/Grid";
import { areYouSureMessage } from "../../../utils/toastMessage/toastMessage";
import { geoAdminContext } from "../../../context/AdminContext/GeoAdminContext/GeoAdminContext";
import { createGeoValidation } from "../../../utils/validation/validation";
import { convertDate } from "../../../utils";

const GeoAdmin = () => {
  const loader = useSelector((state) => state.loader);

  const {
    setCities,
    geo,
    setGeo,
    id,
    isShowModal,
    handleHideModal,
    handleGetGeo,
    handleCreateGeo,
    handleEditGeo,
  } = useContext(geoAdminContext);

  useEffect(() => {
    handleGetGeo();
  }, []);

  // Validation
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(createGeoValidation),
  });

  return (
    <>
      <SiteTitle title="شهر ها" />

      <PageHeader title="شهر ها" />

      <TableContent setValue={setValue} reset={reset} />

      <Modal
        isOpen={isShowModal}
        toggle={() => handleHideModal()}
        className="modal-dialog-centered"
        size="md"
      >
        <ModalBody>
          <span
            type="button"
            onClick={() => handleHideModal()}
            className="close"
          >
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">{id ? "ویرایش شهر" : "افزودن شهر جدید"}</h5>
            <br />
            <Form
              className="is-alter"
              onSubmit={handleSubmit(id ? handleEditGeo : handleCreateGeo)}
            >
              <Row className="gy-4">
                <Col size="12">
                  <FormGroup>
                    <label className="form-label" htmlFor="name">
                      نام
                    </label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        placeholder="نام شهر را وارد نمایید"
                        className="form-control-lg form-control"
                        {...register("name")}
                      />
                      <ErrorMessage message={errors.name?.message} />
                    </div>
                  </FormGroup>
                </Col>
                <Col size="12">
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                    <li>
                      <Button
                        color="primary"
                        size="lg"
                        type="submit"
                        loading={loader}
                      >
                        {id ? "ویرایش" : "افزودن"} شهر
                      </Button>
                    </li>
                    <li>
                      <button
                        type="button"
                        onClick={() => handleHideModal()}
                        className="link link-light"
                      >
                        انصراف
                      </button>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Form>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={!isEmpty(geo)}
        toggle={() => {
          setCities([]);
          setGeo({});
        }}
        className="modal-dialog-centered"
        size="md"
      >
        <ModalBody>
          <span
            type="button"
            onClick={() => {
              setCities([]);
              setGeo({});
            }}
            className="close"
          >
            <Icon name="cross-sm" />
          </span>
          <div className="p-2">
            <h5 className="title">مدیریت شهر های {geo.name}</h5>
            <br />

            <TableContent setValue={setValue} reset={reset} isCity />
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default GeoAdmin;

const TableContent = ({ reset, setValue, isCity }) => {
  const { provinces, cities, handleShowModal, handleGetGeo, handleDeleteGeo } =
    useContext(geoAdminContext);

  const items = isCity ? cities : provinces;

  return (
    <Block>
      <DataTable className="card-stretch">
        <div className="card-inner position-relative card-tools-toggle">
          <div className="card-title-group">
            <div className="card-tools mr-n1">
              <ul className="btn-toolbar gx-1">
                <li className="nk-block-tools-opt">
                  <Button
                    color="primary"
                    className="btn-icon"
                    onClick={() => {
                      handleShowModal();
                      reset();
                    }}
                  >
                    <Icon name="plus" />
                  </Button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <DataTableBody>
          <DataTableHead>
            <DataTableRow>
              <span className="sub-text">#</span>
            </DataTableRow>
            <DataTableRow>
              <span className="sub-text">نام</span>
            </DataTableRow>
            <DataTableRow size="mb">
              <span className="sub-text">تاریخ ایجاد</span>
            </DataTableRow>
            <DataTableRow size="lg">
              <span className="sub-text">تاریخ آخرین ویرایش</span>
            </DataTableRow>
            <DataTableRow />
          </DataTableHead>
          {/*Head*/}
          {items.length > 0
            ? items.map((item, index) => {
                return (
                  <DataTableItem key={item._id}>
                    <DataTableRow>
                      <span>{index + 1}</span>
                    </DataTableRow>
                    <DataTableRow>
                      <span className="tb-lead fw-bold">{item.name}</span>
                    </DataTableRow>
                    <DataTableRow size="mb">
                      <span>
                        {convertDate(item.createdAt, "YYYY/MM/DD - HH:mm")}
                      </span>
                    </DataTableRow>
                    <DataTableRow size="lg">
                      <span>
                        {convertDate(item.updatedAt, "YYYY/MM/DD - HH:mm")}
                      </span>
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col-tools">
                      <ul className="nk-tb-actions gx-1">
                        {!isCity && (
                          <li
                            className="nk-tb-action-hidden"
                            onClick={() => handleGetGeo(item)}
                          >
                            <Tooltip
                              tag="a"
                              containerClassName="btn btn-trigger btn-icon"
                              id={"city" + item._id}
                              icon="globe"
                              direction="top"
                              text="شهر ها"
                            />
                          </li>
                        )}
                        <li
                          className="nk-tb-action-hidden"
                          onClick={() => {
                            reset();
                            handleShowModal(item, setValue);
                          }}
                        >
                          <Tooltip
                            tag="a"
                            containerClassName="btn btn-trigger btn-icon"
                            id={"edit" + item._id}
                            icon="edit-alt-fill"
                            direction="top"
                            text="ویرایش"
                          />
                        </li>
                        <li
                          className="nk-tb-action-hidden"
                          onClick={() =>
                            areYouSureMessage(
                              () => handleDeleteGeo(item._id),
                              `آیا از حذف شهر ${item.name} مطمئنید؟`
                            )
                          }
                        >
                          <Tooltip
                            tag="a"
                            containerClassName="btn btn-trigger btn-icon text-danger"
                            id={"delete" + item._id}
                            icon="trash-fill"
                            direction="top"
                            text="حذف"
                          />
                        </li>
                      </ul>
                    </DataTableRow>
                  </DataTableItem>
                );
              })
            : null}
        </DataTableBody>
        <div className="card-inner">
          {items.length <= 0 && (
            <div className="text-center">
              <span className="text-silent">داده ای برای نمایش یافت نشد</span>
            </div>
          )}
        </div>
      </DataTable>
    </Block>
  );
};
